import EntityFinderTabBase from "./EntityFinderTabBase.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";

export default class EntityFinderResourceTab extends EntityFinderTabBase {
  static get $name() {
    return "EntityFinderResourceTab";
  }

  static get type() {
    return "entityfinderresourcetab";
  }

  static get configurable() {
    return super.getTabWidget("Resources", { type: WIDGET_KEYS.columnEntityMainName, text: "Resource", field: "name" });
  }

  onOpenEntityEditor({ record }) {
    this.editorHandler.openEditor(EDITOR_KEYS.resourceEditorV2, record, {resource: record });
  }

  get storeKey() {
    return STORE_KEYS.resourceStore;
  }
}
EntityFinderResourceTab.initClass();
